module.exports = __webpack_public_path__ + "img/recomendation.15b05ec6.svg";